import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DashboardStateModel } from './models/dashboard.model';

export const DashboardActions = createActionGroup({
  source: 'Dashboard',
  events: {
    'Load Requested': emptyProps(),
    'Load Succeeded': props<{ data: DashboardStateModel }>(),
    'Load Failed': props<{ error: unknown }>(),
    Clear: emptyProps(),
  },
});
